import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FileUploadComponent } from '../../../lead-details/documents/file-upload/file-upload/file-upload.component';
import { SharedService } from '../../../../shared/services/shared.service';
import { STATIC_DATA } from '../../../../shared/constants/static-data.constants';
import { UserService } from '../../../../services/user.service';

@Component({
  selector: 'ppl-authorization-documents',
  standalone: true,
  imports: [FileUploadComponent],
  templateUrl: './authorization-documents.component.html',
  styleUrl: './authorization-documents.component.css'
})
export class AuthorizationDocumentsComponent implements OnInit, OnChanges{
  entry = 'auth';
  filedInfo: any;
  program: any;
  @Input() readonly: boolean = false;
  @Input() id: any;

  constructor(private sharedService: SharedService, private userService: UserService){
  }

  ngOnInit(): void {
    this.program = this.userService.getSelectedProgram();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['id'] && this.id) {
      this.getDocumentsUploaded(false);
    }
  }

  filesUpdated() {
    console.log('Files List update');
    this.getDocumentsUploaded(true);
  }

  getDocumentsUploaded(hasUpdatedEntry?: boolean) {
    this.sharedService.getUploadedFileDetails(this.program.program_code, this.id, this.entry, hasUpdatedEntry).subscribe((data: any) => {
      console.log(data);
      this.filedInfo = data?.responsedata;
    })
  }

}
